export const getOauthCompanyName = (companyName = ''): string => {
  return companyName.toLocaleLowerCase().split(' ').join('-');
};
